module.exports = __webpack_public_path__ + "static/media/Soham_Dombale.7ac688d8.jpg";